import { render, staticRenderFns } from "./PreviewQuestion.vue?vue&type=template&id=305547f6"
import script from "./PreviewQuestion.vue?vue&type=script&lang=js"
export * from "./PreviewQuestion.vue?vue&type=script&lang=js"
import style0 from "./PreviewQuestion.vue?vue&type=style&index=0&id=305547f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports